import { ZodSchema } from "@validation/utils/schemaUtils";
import { z } from "zod";

export const templateSchema = z.object({
	id: z.number().nullable(),
	name: z.string(),
	version: z.string().nullable(),
	preferredLanguage: z.object({
		id: z.number(),
		code: z.string(),
		description: z.string(),
	}).nullable(),
	latestTemplates: z.array(z.object({
		id: z.number().nullable(),
		template: z.string(),
		version: z.string().nullable(),
		isFinal: z.boolean(),
		subject: z.string(),
		name: z.string(),
		created: z.number(),
		language: z.object({
			id: z.number(),
			code: z.string(),
			description: z.string(),
		}),
	})),
});

export type TemplateSchemaInput = z.input<typeof templateSchema>;
export type TemplateSchemaOutput = z.output<typeof templateSchema>;

export const templateLanguageSchema = z.object({
	language: ZodSchema.requiredField(z.object({
		id: z.number(),
		code: z.string(),
		description: z.string(),
	})),
});

export type TemplateLanguageSchemaInput = z.input<typeof templateLanguageSchema>;
export type TemplateLanguageSchemaOutput = z.output<typeof templateLanguageSchema>;
